<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
          style="padding-top:0;margin-top:0" size="medium">
          <el-form-item label="客户：">
            <el-select v-model="searchForm.TC_ID" filterable placeholder="请选择" clearable @clear="clearEvent()"
              @change="onTCChange">
              <el-option v-for="item in companys" :key="item.value" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select v-model="searchForm.PROJECT_ID" filterable multiple placeholder="请选择" clearable
              @change="queryDkList">
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select v-model="searchForm.DK_ID" filterable multiple placeholder="请选择" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select v-model="searchForm.SUPPLIER_ID" filterable placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.value" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择日期：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单类型：">
            <el-select filterable v-model="searchForm.ADDED_ORDER" placeholder="请选择" clearable>
              <el-option v-for="item in addedOrderTypeList" :key="item.value" :label="item.NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="searchForm.ORDER_ID" style="width: 180px;" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" id="search" @click="handleSearch">筛选</el-button>
            <el-button type="primary" plain @click="batchExport">批量导出</el-button>
            <el-button type="primary" plain @click="purchaseOrderExport">采购订单导出</el-button>
            <el-button type="primary" plain @click="exportPurchaseSaleMerge">采购销售信息合并导出</el-button>
            <el-button type="primary" plain @click="exportPdf(1)">销售单PDF导出</el-button>
            <el-button type="primary" plain @click="exportPdf(2)">采购单PDF导出</el-button>
            <el-button type="primary" plain @click="openImportThirdPartyOrder" v-show="fun_dic[1030602]">
              导入第三方订单
            </el-button>
            <el-button v-show="fun_dic[1030603]" type="primary" plain @click="exportMergePdf(2)">导出合并PDF</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border stripe show-summary
          :summary-method="getSummaries" style="width: 100%">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="ID" label="订单ID" width="100"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" width="95"></el-table-column>
          <el-table-column prop="VENDOR_NAME" label="供货商"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="门店"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="REAL_PURCHASE_FEE" label="采购验收总金额"></el-table-column>
          <el-table-column prop="THIRD_REAL_SALE_FEE" label="销售验收总金额"></el-table-column>
          <el-table-column prop="ADDED_ORDER" label="订单类型">
            <template slot-scope="scope">
              {{ getAddedOrderTypeLabel(scope.row.ADDED_ORDER) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="50">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 导出合并PDF订单 -->
    <el-dialog title="批量导出" center :visible.sync="exportOrderFormDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="exportMergeForm" ref="exportMergeForm" :inline="true" :rules="rules">
        <el-form-item label="客户：" prop="COMPANY" label-width='150px'>
          <el-select style="width:300px" v-model="exportMergeForm.COMPANY" filterable placeholder="请选择" clearable
            @change="queryProjectList()">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店：" prop="PROJECT" label-width='150px'>
          <el-select style="width:300px" v-model="exportMergeForm.PROJECT" filterable placeholder="请选择" clearable>
            <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" prop="SEND_DAY" label-width='150px'>
          <el-date-picker style="width:300px" :picker-options="pickerOptions" v-model="exportMergeForm.SEND_DAY"
            type="date" placeholder="选择日期" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否打印价格：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportMergeForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否打印送货数量：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="exportMergeForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="exportMergeForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportClose">取 消</el-button>
        <el-button size="small" :loading="loading1" @click="submitExportAdd('exportMergeForm')">确 定</el-button>
      </div>
    </el-dialog>
    <DSOrderExportPDFForm v-if="exportPdfDialogVisible" :prop-visible="exportPdfDialogVisible"
      :price-type="exportPdfForm.priceType" :order-status="3" :is-yfd="isYFD"
      :order-id-list="checkedArray.map(({ ORDER_ID }) => ORDER_ID)" :prop-customer-list="companys"
      @close="exportPdfDialogVisible = false">
    </DSOrderExportPDFForm>

    <el-dialog :visible.sync="importThirdPartyOrderVisible" title="导入第三方订单" width="400px" center>
      <el-form ref="orderForm">
        <el-upload :data="$uploadParams" class="upload-demo" ref="upload" action="/uploadFile" :on-remove="handleRemove"
          :on-success="handleSuccess" name="exportOut" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downloadTemplate" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importThirdPartyOrderVisible = false">取消</el-button>
        <el-button class="operate-btn" @click="confirmImportThirdPartyOrder">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  DSOrderFun, queryCustomerFun, haveSupplierFun,
} from '@/assets/api/DSOrder';
import date from '@/assets/common/date';
import { frontEndFun } from '@/assets/api/frontFun';
import {
  selectProjectFun, batchExportFun, getHaveSupplyRelationshipProjectList,
} from '@/assets/api/sellOrder';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import DSOrderExportPDFForm from './DSOrderExportPDFForm.vue';
import validation from '@/assets/common/validation';
import orderMixin from '@/assets/common/mixins/orderMixin.js';

export default {
  components: {
    DSOrderExportPDFForm,
  },
  mixins: [orderMixin],
  data () {
    return {
      isYFD: 0,
      fileList: [],
      PAGE_ID: '10306', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1030601: 0, 1030602: 0, 1030603: 0 }, // 功能ID 一旦规定不要轻易改动
      rules: {
        COMPANY: [
          { required: true, message: '请选择客户', trigger: 'blur' },
        ],
      },
      printFormDialog: false,
      printForm: {
        printPrice: '0',
        printCount: '0',
      },
      loading: false,
      loading1: false,
      loading2: false,
      importThirdPartyOrderVisible: false,
      exportTatolDialog: false,
      converForm: {
        SEND_DAY: new Date(),
      },
      converFormVisible: false,
      converAllForm: {
        SEND_DAY: new Date(),
      },
      converAllFormVisible: false,
      companys: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      exportMergeForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
      },
      pickerOptions1: {},
      exportForm: {
        DAY_INTERVAL: [],
      },
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 15,
      searchForm: {
        TC_ID: '',
        DAY_INTERVAL: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date(), '%F')],
        PROJECT_ID: [],
        SEND_DAY: '',
        pageSize: 15,
      },
      unConversionVisible: false,
      unTableData: [],
      tableData: [],
      tmpOrderId: [],
      checkedArray: [],
      submitArr: [],
      supplierList: [],
      points: [],
      dkList: [],
      loading3: false,
      loading4: false,
      orderPrintForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
      },
      exportOrderFormDialog: false,
      projects: [],
      exportFlag: 0,
      ORDER_ID: 0,
      value1: '',
      exportPdfDialogVisible: false,
      exportPdfForm: {
        priceType: 1,
      },
    };
  },
  created () {
    if (this.DSHISTORY_ORDER_LIST_CONDITION.CONDITION) {
      this.searchForm = this.DSHISTORY_ORDER_LIST_CONDITION.CONDITION;
      this.currentPage = this.DSHISTORY_ORDER_LIST_CONDITION.CURRENT_PAGE;
    }
    this.queryProject();
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 15;
    this.queryBeforeFun();
    this.queryCustomer();
    this.querySupplier();
    if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
      this.queryDkList();
    }
    this.queryData();
  },
  computed: {
    // 上一次的搜索结果和条件
    DSHISTORY_ORDER_LIST_CONDITION () {
      return this.$store.state.DSHISTORY_ORDER_LIST_CONDITION;
    },
  },
  methods: {
    confirmImportThirdPartyOrder () {
      if (!this.file_name) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 80,
        FILE: this.file_name,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (JSON.stringify(result[0]) != '{}') {
          window.open(util.getURLLocalHost(result[0]));
          this.$message.show({ text: '查看结果', type: 'success' });
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
        }
        this.file_name = '';
        this.$refs.upload.clearFiles();
        this.importThirdPartyOrderVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    handleSuccess (response, file, fileList) {
      this.file_name = response.file_name;
    },
    downloadTemplate () {
      window.open('/file/templates/第三方订单导入模板表.xls');
    },
    handleRemove (file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    // 采购订单导出
    purchaseOrderExport () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 15,
        STATUS: 3,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 必传GYS_ID(供应链ID),STATUS(状态)(1:待送,2待确认,3历史),START_DAY(开始日期),END_DAY(结束日期)
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择开始日期和结束日期', type: 'warning' });
        return;
      }
      // 选传TC_ID(客户ID),SUPPLIER_ID(供应商ID)
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      http.post(params).then((result) => {
        if (result[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        } else if (result[0].FILE_PATH !== '') {
          window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 批量导出
    batchExport () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 13,
        STATUS: 3,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 必传GYS_ID(供应链ID),STATUS(状态)(1:待送,2待确认,3历史),START_DAY(开始日期),END_DAY(结束日期)
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        //   if (判断日期范围是否超过限制(...this.searchForm.DAY_INTERVAL)) {
        //     this.$message.show({ text: '日期范围不能超过31天', type: 'warning' });
        //     return;
        //   }
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择开始日期和结束日期', type: 'warning' });
        return;
      }
      // 选传TC_ID(客户ID),SUPPLIER_ID(供应商ID)
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      http.post(params).then((result) => {
        if (result[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        } else if (result[0].FILE_PATH !== '') {
          window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCustomer () {
      const params = {};
      queryCustomerFun(params).then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].company;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
      });
    },
    querySupplier () {
      haveSupplierFun().then((result) => {
        this.supplierList = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    clearEvent () {
      this.queryData();
    },
    // 多选框
    handleSelectionChange (val) {
      this.checkedArray = val.map((item) => ({ ORDER_ID: item.ID }));
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    detail (row) {
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('tcName', row.TC_NAME);
      sessionStorage.setItem('DSOrderDetailTitle', JSON.stringify({
        ORDER_ID: row.ID,
        SEND_DATE: row.SEND_DAY,
        CUSTOMER_NAME: row.TC_NAME,
        PROJECT_NAME: row.PROJECT_NAME,
        DK_NAME: row.DK_NAME,
      }));
      this.$router.push({ path: '/DSHistoryDetail/detail' });
    },
    // -----------------------获取新订单列表
    handleSearch () {
      this.currentPage = 1;
      this.queryData();
    },
    // 拉取项目点
    queryProject () {
      const params = {};
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变项目点 拉取档口
    queryDkList () {
      if (this.searchForm.PROJECT_ID.length === 0) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECTS_ID = this.searchForm.PROJECT_ID;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = util.listRemoveDuplicates(result);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    queryData () {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: this.pageSize ? this.pageSize : 20,
        PAGEINDEX: this.currentPage - 1,
        STATUS: 3,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID && this.searchForm.DK_ID.length !== 0) {
        params.DK_IDS = this.searchForm.DK_ID;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      DSOrderFun(params).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
          this.$store.dispatch('SET_DSHISTORY_ORDER_LIST_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close () {
      this.exportTatolDialog = false;
      this.converAllFormVisible = false;
      this.tmpOrderId = [];
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    print (row) {
      this.$router.push({ name: 'printPreview' });
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('pricePrint', 0);
    },
    pricePrint (row) {
      this.$router.push({ name: 'printPreview' });
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('pricePrint', 1);
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'TOTAL_GYS_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        }
      });
      this.sums = sums;
      return sums;
    },
    submitDialog () {
      if (this.exportFlag == 3) {
        this.submitExportSell();
      } else if (this.exportFlag == 4) {
        this.submitExportPurchase();
      } else {
        this.submitOrderPrint();
      }
    },
    exportClose () {
      this.exportOrderFormDialog = false;
    },
    queryProjectList () {
      const paramsProject = {
        TC_ID: this.exportMergeForm.COMPANY,
      };
      selectProjectFun(paramsProject).then((result) => {
        this.projects = result[0].list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitExportAdd () {
      if (this.exportMergeForm.SEND_DAY) {
        this.$refs.exportMergeForm.validate((valid) => {
          if (valid) {
            const params = {
              SEND_DAY: date(this.exportMergeForm.SEND_DAY, '%F'),
              TC_ID: this.exportMergeForm.COMPANY,
              PRICE_FLAG: Number(this.exportMergeForm.printPrice),
              ORDER_FLAG: 1,
              SEND_COUNT_FLAG: Number(this.exportMergeForm.printCount),
              DS_FLAG: 1,
              iRCONTFlag: Number(this.exportMergeForm.printReal),
            };
            if (this.exportMergeForm.PROJECT !== '') {
              params.PROJECT_ID = this.exportMergeForm.PROJECT;
            }
            this.loading1 = true;
            batchExportFun(params).then((result) => {
              window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
              this.exportMergeFormDialog = false;
              this.$nextTick(() => {
                this.$refs.exportMergeForm.resetFields();
              });
              this.loading1 = false;
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading1 = false;
            });
          } else {
            return false;
          }
        });
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
    },
    exportPurchaseSaleMerge () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 66,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        STATUS: 3,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID && this.searchForm.DK_ID.length !== 0) {
        params.DK_IDS = this.searchForm.DK_ID;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      http.post(params).then((result) => {
        if (result[0]) {
          if (result[0].TASK_CREATED_SUCCESSFULLY) {
            this.$util.getUnreadInformation(this);
            this.$confirm(this.$util.appointmentMessage, '温馨提示', {
              confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
            }).then(() => {
              this.$router.push({ name: 'appointmentHandling' });
            }).catch(() => {
              this.$message.show({ type: 'info', text: '取消操作' });
            });
          } else if (result[0].FILE_PATH) {
            window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
          }
        } else this.$message.show({ type: 'warning', text: '暂无数据' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openImportThirdPartyOrder () {
      this.importThirdPartyOrderVisible = true;
    },
    exportMergePdf (priceType) {
      this.isYFD = 1;
      this.exportPdfForm.priceType = priceType;
      this.exportPdfDialogVisible = true;
    },
    exportPdf (priceType) {
      this.exportPdfForm.priceType = priceType;
      this.exportPdfDialogVisible = true;
    },
    onTCChange () {
      this.searchForm.PROJECT_ID = [];
      this.queryProject();
    },
  },

};
</script>
<style scoped>
.el-button--text {
  margin: 0 0 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSHistoryOrderList.vue